import React, { createContext } from 'react'
const WidgetContext = createContext({
  host: null,
  apiKey: null,
  franchise: null,
  brand: null,
  client: () => {},
  setUnrecoverableError: () => {},
})
export default WidgetContext

